export const RAMO_HOSPITALIZACION = 95;

export const TIPO_CONTRATO = {
  LITRO: "LITRO",
  MONTO: "MONTO",
};

export const COBERTURA_OXIGENO = 1083;
export const COBERTURA_HABITACION = 1064;
export const COBERTURA_ANESTESIA = 1096;
export const COBERTURA_PARTO_NORMAL = 910;
export const COBERTURA_CESAREA = 903;

/** Coberturas con monto reclamado abierto: solo validación al inicio, monto no es límite×frecuencia, Monto Pagar ARS y Dif. No Cub. calculados en front. */
export const COBERTURAS_MONTO_ABIERTO = [1083, 1065, 1096, 1114]; // Oxígeno y otras coberturas abiertas

export const esCoberturaMontoAbierto = (codigo) =>
  COBERTURAS_MONTO_ABIERTO.includes(Number(codigo));

export const SERVICIO_AMBULATORIO = "1";
export const SERVICIO_HOSPITALIZACION = "2";
export const SERVICIO_EMERGENCIA = "4";
export const SERVICIO_MATERNIDAD = "5";
export const SERVICIO_PARTO = "11";
export const SERVICIO_CESAREA = "12";

export const LITROS_REGEX = /^\d{0,6}(\.\d{0,3})?$/;
export const MONTO_REGEX = /^(\d{0,10})?(\.\d{0,2})?$/;

export const MAXIMO_DIAS_CONSULTA_CIERRES = 31;

export const INITIAL_STATE_FORM_CONSULTA_CIERRES = {
  numeroReclamo: "",
  nombreAsegurado: "",
  fechaInicio: "",
  fechaFin: "",
  numeroCarnet: "",
  cedula: "",
  plan: "",
  servicio: "",
  fechaServicioDesde: "",
  fechaServicioHasta: "",
  medicoSeleccionado: null,
  paginaActual: 1,
  tamanoPagina: 10,
  showAlert: false,
  alertConfig: {},
  dataCierres: null,
};
